import { useHistory } from 'react-router-dom'
import AISparkle from 'images/ai-sparkle.svg'
import HandIcon from 'images/hand-icon.svg'
import TaxonomyIcon from 'images/taxonomy_icon.svg'
import { ROUTES } from 'routes'
import { Button } from './button'
import { PageHeader } from './page-header'
import { t } from '@lingui/core/macro'

interface Props {
  onFeedbackClick: () => void
}

export const TaxonomyTranslationHeader = ({ onFeedbackClick }: Props) => {
  const history = useHistory()

  const handleNewTaxonomyTranslation = () => {
    history.push(ROUTES.TAXONOMY_TRANSLATION_UPLOAD)
  }

  return (
    <PageHeader>
      <PageHeader.LeftBlock>
        <TaxonomyIcon />
        <PageHeader.TitleContainer>
          <PageHeader.Title className="flex gap-2">
            {t`Taxonomy translation`}
            <AISparkle />
          </PageHeader.Title>
          <PageHeader.Description className="text-sm">
            {t`Harmonize taxonomies between clients and agencies in minutes`}
          </PageHeader.Description>
        </PageHeader.TitleContainer>
      </PageHeader.LeftBlock>
      <PageHeader.RightBlock>
        <Button
          onClick={onFeedbackClick}
          variant="outline"
          className="border-[#0092F3] text-[#0092F3] hover:bg-[#0092F3] hover:text-white"
        >
          <div className="flex gap-2 items-center">
            <HandIcon className="fill-current hover:fill-white" />
            <span>{t`Give feedback`}</span>
          </div>
        </Button>
        <Button onClick={handleNewTaxonomyTranslation}>
          <span>{t`New taxonomy translation`}</span>
        </Button>
      </PageHeader.RightBlock>
    </PageHeader>
  )
}
